import { CardActions } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const simpleDialogCommonContentClasses = makeStyles(() => ({
  Card: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid black',
    borderRadius: 9,
    height: '100%',
  },
  cardActions: { padding: 16 },
  cardContent: { overflowY: 'auto', height: '100%', display: 'flex', flexDirection: 'column', gap: 10 },
}));

const SimpleDialogCommunContent = ({ header, content }) => {
  const classes = simpleDialogCommonContentClasses();

  return (
    <Card className={classes.Card}>
      <CardActions className={classes.cardActions}>{header}</CardActions>
      <CardContent className={classes.cardContent}>{content}</CardContent>
    </Card>
  );
};

export default SimpleDialogCommunContent;
